import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const manageMemberSlice = createSlice({
  name: 'manageMember',
  initialState: {
    employees: [],
    employeesDefault: [],
    searchParam: null,
    searchText: '',
    loading: false,
    newUser: 0,
    newUserList: [],
    searchedColumn: '',
    countEmployees: 0,
    page: 1,
    pageSize: 10,
    prepareDataForDetail: []
  },
  reducers: {
   setEmployeesRedux: (state, action) => {
    const { employees } = action.payload
    state.employees = employees
   },
   setEmployeeSpecificRedux: (state, action) => {
    const { index, key, value } = action.payload
    state.employees[index][key] = value
    state.employeesDefault[index][key] = value
   },
   setEmployeesWithIndexRedux: (state, action) => {
    const { employee, index } = action.payload
    state.employees[index] = employee
    state.employeesDefault[index] = employee
   },
   setEmployeesWithIndexAndSearchingRedux: (state, action) => {
    const { employee, index } = action.payload
    state.employees[index] = employee
   },
   setEmployeesDefaultRedux: (state, action) => {
    const { employeesDefault } = action.payload
    state.employeesDefault = employeesDefault
   },
   setSearchParamRedux: (state, action) => {
    const { searchParam } = action.payload
    state.searchParam = searchParam
   },
   setSearchTextRedux: (state, action) => {
    const { searchText } = action.payload
    state.searchText = searchText
   },
   setLoadingRedux: (state, action) => {
    const { loading } = action.payload
    state.loading = loading
   },
   setNewUserRedux: (state, action) => {
    const { newUser } = action.payload
    state.newUser = newUser
   },
   setNewUserListRedux: (state, action) => {
    const { newUserList } = action.payload
    state.newUserList = newUserList
   },
   setSearchedColumnRedux: (state, action) => {
    const { searchedColumn } = action.payload
    state.searchedColumn = searchedColumn
   },
   setCountEmployeesRedux: (state, action) => {
    const { countEmployees } = action.payload
    state.countEmployees = countEmployees
   },
   setPageRedux: (state, action) => {
    const { page } = action.payload
    state.page = page
   },
   setPageSizeRedux: (state, action) => {
    const { pageSize } = action.payload
    state.pageSize = pageSize
   },
   setPrepareDataForDetailRedux: (state, action) => {
    const { prepareDataForDetail } = action.payload
    state.prepareDataForDetail = prepareDataForDetail
   },
  },
})

export default manageMemberSlice.reducer;

export const {
  setEmployeesRedux,
  setEmployeeSpecificRedux,
  setEmployeesDefaultRedux,
  setSearchParamRedux,
  setSearchTextRedux,
  setLoadingRedux,
  setNewUserRedux,
  setNewUserListRedux,
  setSearchedColumnRedux,
  setCountEmployeesRedux,
  setPageRedux,
  setPageSizeRedux,
  setPrepareDataForDetailRedux,
  setEmployeesWithIndexRedux,
  setEmployeesWithIndexAndSearchingRedux,
} = manageMemberSlice.actions

export const getEmployeesRedux = (state) => state.manageMember.employees
export const getEmployeesDefaultRedux = (state) => state.manageMember.employeesDefault
export const getSearchParamRedux = (state) => state.manageMember.searchParam
export const getSearchTextRedux = (state) => state.manageMember.searchText
export const getLoadingRedux = (state) => state.manageMember.loading
export const getNewUserRedux = (state) => state.manageMember.newUser
export const getNewUserListRedux = (state) => state.manageMember.newUserList
export const getSearchedColumnRedux = (state) => state.manageMember.searchedColumn
export const getCountEmployeesRedux = (state) => state.manageMember.countEmployees
export const getPageRedux = (state) => state.manageMember.page
export const getPageSizeRedux = (state) => state.manageMember.pageSize
export const getPrepareDataForDetailRedux = (state) => state.manageMember.prepareDataForDetail